//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// UI logic:
//    The background curtain property is required, can not be deselected, and can be only one property.
//    The foreground curtain properties are optional, can be deselected and can be multiple properties.
const isEqual = require("lodash.isequal");

import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
    };
  },

  methods: {
  },
  computed: {
    ...mapGetters("preferences", ["curtainPropertyJSON"]),
    bgCurtainProp: {
      get() {
        return this.$store.state.curtains.selectedCurtainProperties[0];
      },
      set(value) {
        if (isEqual(value._name ? value._name : value, this.$store.state.curtains.selectedCurtainProperties[0])) {
          console.log("The new selected background curtain property is the same as the old one.");
          return;
        }
        const newCurtainProperties = [value._name ? value._name : value, ...this.$store.state.curtains.selectedCurtainProperties.slice(1)];
        this.$store.commit("curtains/updateSelectedCurtainProperties", newCurtainProperties);
      }
    },
    fgCurtainProps: {
      get() {
        return this.$store.state.curtains.selectedCurtainProperties.slice(1);
      },
      set(value) {
        if (isEqual((value.map(obj => obj._name ? obj._name : obj)), this.$store.state.curtains.selectedCurtainProperties.slice(1))) {
          console.log("The new selected foreground curtain properties are the same as the old ones.");
          return;
        }
        const newCurtainProperties = [this.$store.state.curtains.selectedCurtainProperties[0], ...(value.map(obj => obj._name ? obj._name : obj))];
        this.$store.commit("curtains/updateSelectedCurtainProperties", newCurtainProperties);
      }
    },
    showSecondCurtain: {
      get() {
        return this.$store.state.curtains.selectedCurtainProperties.length > 1 ? true : false;
      }
    },
    secondCurtainOpacity: {
      get() {
        return parseInt(
          100 * this.$store.state.preferences.logsView.secondCurtainOpacity
        );
      },
      set(value) {
        this.$store.commit(
          "preferences/updateSecondCurtainOpacity",
          parseInt(value) / 100
        );
      }
    }
  },
  watch: {
  }
};
